import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

/**
 * Fetch the current TrustScore breakdown for an operator.
 *
 * The endpoint returns a single row with:
 *   - overall_score + per-facet scores (safety, financial, regulatory, aog)
 *   - factors.tail_breakdown + factors.fleet_breakdown component maps
 *
 * Cached under ['operator', id, 'trust-scores'] so multiple consumers
 * on the same page dedupe automatically. staleTime of 5 minutes matches
 * usePlatformFeeRate — TrustScore recomputes are back-end triggered, not
 * something the UI does mid-session.
 */
export const useOperatorTrustScore = (operatorId) => {
  return useQuery({
    queryKey: ['operator', operatorId, 'trust-scores'],
    queryFn: () => apiClient.getOperatorTrustScores(operatorId),
    enabled: !!operatorId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
